import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'simple-react-i18n'
import { useSelector } from 'react-redux'
import StyledCard from './StyledCard'
import { Grid } from '@mui/material'
import DtoCity from '../../referencials/city/dto/DtoCity'

const LocalizationCard = ({ title, styleContainer, data }) => {
    const {
        citiesIndex,
        cities,
    } = useSelector(store => ({
        citiesIndex: store.CityReducer.citiesIndex,
        cities: store.CityReducer.cities,
    }))

    const getSelectedItem = () => {
        const city = citiesIndex[data.townCode]
        return city || {}
    }

    if (cities.length) {
        const city = getSelectedItem()
        return (
            <StyledCard
                subTitle={title}
                styleContainer={styleContainer}
                styleSubTitle={{ borderTop: '1px solid black' }}
                styleContent={{ padding: 0 }}
            >
                <Grid container style={{ padding: 10 }}>
                    <Grid item xs={6} className='bold' style={{ color: 'grey' }}>{i18n.city}</Grid>
                    <Grid item xs={6} className='bold'>{city?.name || '-'}</Grid>
                </Grid>
                <Grid container style={{ padding: 10, borderTop: '1px solid black' }}>
                    <Grid item xs={6} className='bold' style={{ color: 'grey' }}>{i18n.codeParcelle}</Grid>
                    <Grid item xs={6} className='bold'>{data?.link_geo?.length ? `${data.link_geo[0].parcel} ${data.link_geo[0].section}` : '-'}</Grid>
                </Grid>
                <Grid container style={{ padding: 10, borderTop: '1px solid black' }}>
                    <Grid item xs={6} className='bold' style={{ color: 'grey' }}>{i18n.lieuDit}</Grid>
                    <Grid item xs={6} className='bold'>{data?.location || '-'}</Grid>
                </Grid>
                <Grid container style={{ padding: 10, borderTop: '1px solid black' }}>
                    <Grid item xs={6} className='bold' style={{ color: 'grey' }}>{i18n.xLambert}</Grid>
                    <Grid item xs={6} className='bold'>{data?.x || '-'}</Grid>
                </Grid>
                <Grid container style={{ padding: 10, borderTop: '1px solid black' }}>
                    <Grid item xs={6} className='bold' style={{ color: 'grey' }}>{i18n.yLambert}</Grid>
                    <Grid item xs={6} className='bold'>{data?.y || '-'}</Grid>
                </Grid>
            </StyledCard>
        )
    }
    return ''
}

LocalizationCard.propTypes = {
    title: PropTypes.string.isRequired,
    data: PropTypes.instanceOf(PropTypes.shape({})),
    styleContainer: PropTypes.instanceOf(PropTypes.shape({})),
    citiesIndex: PropTypes.instanceOf(PropTypes.shape({})),
    cities: PropTypes.instanceOf(PropTypes.instanceOf(DtoCity)),
}

export default LocalizationCard